import { render, staticRenderFns } from "./LoginAsCustomer.vue?vue&type=template&id=d442fda8&"
import script from "./LoginAsCustomer.vue?vue&type=script&lang=js&"
export * from "./LoginAsCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports